module.exports = __webpack_public_path__ + "img/ch73.efd00a52.jpg";